import React, { useState, useEffect, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EmployeeForm from "./EmployeeForm";
import {
  getEmployeeById,
  getCareerLevels,
  getContractTypes,
  updateEmployeeInquiryResponses,
  updateEmployeeImage,
  getEmployeeImageById,
  getEmployees,
  updateIntegration,
  updateProfileEmail,
  updateFirstMonthAssessmentEmail,
  addEmployee,
  updateEmployee,
  updateInquiry,
} from "../../api/EmployeeApi";
import { getTemplateQuestions, getTemplates } from "../../api/TemplateApi";
import { getTechSpecialized } from "../../api/TechSpecializedApi";
import {
  checkIfEmployeeIsUnderManager,
  GetUserByDepartmentId,
  getUserById,
} from "../../api/UserApi";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { Form } from "antd";
import moment from "moment";
import {
  addEmployeeOffer,
  getEmployeeOfferByEmployeeList,
  getEmployeeOffersCounters,
  updateEmployeeOffer,
} from "../../api/EmployeeOfferApi";
import { getEmployeeContractHistory } from "../../api/EmployeeContractHistoryApi";
import { getOfferLists } from "../../api/OfferApi";
import { getAuthenticatedUserId } from "../../api/ApiUtils";
import { getCriticalSituations } from "../../api/CriticalSituationApi";
import {
  adnPageSize,
  appTitle,
  dateFormat,
  Departement,
  ContractType,
  CriticalSituationStatus,
} from "../common/GeneralConfigurations";
import {
  getEmployeeFollowUpEventsCounters,
  getEmployeesSatisfactionLevels,
  getFollowUpEventByEmployeeId,
  getEmployeeFollowUpEventById,
  updateEmployeeFollowUpEvent,
  checkPreviousUnresolvedEmployeeFollowUpEventsById,
} from "../../api/EmployeeFollowUpEventApi";
import { getEmployeeCertificationByEmployeeId } from "../../api/EmployeeCertificationApi";
import { getFirstMonthAssessmentQuestionsByEmployeeId } from "../../api/FirstMonthAssessmentApi";
import { getWorkPlaces } from "../../api/WorkPlaceApi";
import { getCountries } from "../../api/CountryApi";
import {
  getEmployeeRecommendationBenefitsByEmployeeId,
  updateCanceledEmployeeRecommendationBenefits,
} from "../../api/EmployeeRecommendationBenefitsApi";
import { adnNotification } from "../common/adnNotification/adnNotification";
import { AppRoutes } from "../../AppRoutes";
import { getResignationReasons } from "../../api/ResignationReasonApi";
import { getSetting } from "../../api/SettingApi";
import { getDepartments } from "../../api/DepartmentApi";

const checkObjEmpty = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

const ManageEmployeePage = () => {
  const { t } = useTranslation();

    const academyContractId = 4;
    const params = useParams();
    const employeeId = params.id; //parseInt(params.id, 10);
    const navigate = useNavigate();
    const [formOffers] = Form.useForm();
    const [formEmail] = Form.useForm();
    const [searchParams, setSearchParams] = useSearchParams();

  const [pageHeader, setPageHeader] = useState("");
  const [loadEditPreviewData, setLoadEditPreviewData] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [templateAlreadySelected, setTemplateAlreadySelected] = useState(false);

    //Setting occasion, Add or editing
    const isEditing = params.id;
    const [isSentInquiryEmail, setIsSentInquiryEmail] = useState(false);
    const [isInquiryAnswered, setIsInquiryAnswered] = useState(false);
    const [isFirstMonthAssessmentEmailSent, setIsFirstMonthAssessmentEmailSent] = useState(false);
    const [isFirstMonthAssessmentAnswered, setIsFirstMonthAssessmentAnswered] = useState(false);
    // Form control states
    const [consultantForm] = Form.useForm();
    const [inquiryForm] = Form.useForm();
    const [isConsultant, setIsConsultant] = useState(true);
    const [templates, setTemplates] = useState([]);
    const [templateQuestions, setTemplateQuestions] = useState([
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
    ]);
    const [selectedTemplateId, setSelectedTemplateId] = useState([]);
    const [careerLevels, setCareerLevels] = useState([]);
    const [inTransition, setInTransition] = useState(false);
    const [availableCareerLevels, setAvailableCareerLevels] = useState([]);
    const [contractTypeList, setContractTypeList] = useState([]);
    const [techSpecializedList, setTechSpecializedList] = useState([]);
    const [techSpecializedName, setTechSpecializedName] = useState("");
    const [managersList, setManagersList] = useState([]);
    const [humanResList, setHumanResList] = useState([]);
    const [initValues, setInitValues] = useState();
    const [workPlaceList, setWorkPlaceList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [haveAdmissionCti, setHaveAdmissionCti] = useState(false);
    const [haveAdmissionCps, setHaveAdmissionCps] = useState(false);
    const [criticalSituationsLinkPath, setCriticalSituationsLinkPath] = useState();
    const [departmentList, setDepartmentList] = useState([]);

  const [isCTI, setIsCTI] = useState(false);
  const [fluencyLanguages, setFluencyLanguages] = useState({
    pt: true,
    en: false,
    es: false,
    ge: false,
    gr: false,
    it: false,
    fr: false,
  });
  const [employeeFollowUpEventData, setEmployeeFollowUpEventData] = useState(
    []
  );
  const [employeeCertificationData, setEmployeeCertificationData] = useState(
    []
  );
  const [
    totalRecordsEmployeeCertification,
    setTotalRecordsEmployeeCertification,
  ] = useState(0);
  const [image, setImage] = useState(null);
  const [orderByFollowUp, setOrderByFollowUp] = useState("name");
  const [currentPageFollowUp, setCurrentPageFollowUp] = useState(1);
  const [totalRecordsFollowUp, setTotalRecordsFollowUp] = useState(10);
  const [isIntegrationEmailSent, setIsIntegrationEmailSent] = useState(0);
  const [isProfileEmailSent, setIsProfileEmailSent] = useState(false);
  const [searchReferenceBy, setSearchReferenceBy] = useState("");
  const [referenceByEmployees, setReferenceByEmployees] = useState([]);
  const [referenceById, setReferenceById] = useState(null);
  const [referenceByName, setReferenceByName] = useState(null);
  const [isFirstAwardPaid, setIsFirstAwardPaid] = useState(null);
  const [isSecondAwardPaid, setIsSecondAwardPaid] = useState(null);
  const [
    visibleCancelRecommendationsModal,
    setVisibleCancelRecommendationsModal,
  ] = useState(false);

  // Contract History
  const [showContractHistoryModal, setShowContractHistoryModal] =
    useState(false);
  const [employeeContractHistory, setEmployeeContractHistory] = useState([]);

  //Email
  const [emailModalTitle, setEmailModalTitle] = useState("");
  const [visibleModalEmail, setVisibleModalEmail] = useState(false);
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [isEmailEnglishLanguage, setisEmailEnglishLanguage] = useState(0);
  //Offers
  const [visibleModalOffer, setVisibleModalOffer] = useState(false);
  const [event, setEvent] = useState("");
  const [offerData, setOfferData] = useState([]);
  const [employeeOfferData, setEmployeeOfferData] = useState([]);
  const [offerHandler, setOfferHandler] = useState({});
  const [modalSubmitLoading, setModalSubmitLoading] = useState(false);
  const [cancelOfferVisible, setCancelOfferVisible] = useState(false);
  const [offerFormValues, setOfferFormValues] = useState();
  const [cancelOfferForm] = Form.useForm();

  //Loading
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const [emailSubmitLoading, setEmailSubmitLoading] = useState(false);
  //Statistics
  const [companySatisfaction, setCompanySatisfaction] = useState(0);
  const [projectSatisfaction, setProjectSatisfaction] = useState(0);
  const [clientSatisfaction, setClientSatisfaction] = useState(0);
  const [employeeOffersCounters, setEmployeeOffersCounters] =
    useState(undefined);
  const [employeeFollowUpEventsCounters, setEmployeeFollowUpEventsCounters] =
    useState(undefined);

  //Tags
  const [tags, setTags] = useState([]);
  const [tecnologiesString, setTecnologiesString] = useState("");
  const [tagInputVisible, setTagInputVisible] = useState(false);
  const [tagInputValue, setTagInputValue] = useState("");
  const [editTagInputIndex, setTagEditInputIndex] = useState(-1);
  const [editTagInputValue, setTagEditInputValue] = useState("");
  const tagInputRef = useRef(null);
  const tagEditInputRef = useRef(null);
  //
  const [isManager, setIsManager] = useState(false);
  const [managerEditPermission, setManagerEditPermission] = useState(true);
  //
  const [percentage, setPercentage] = useState(0);

  //FollowUpEvents
  const [eventFormValues, setEventFormValues] = useState({});
  const [cancelEventVisible, setCancelEventVisible] = useState(false);
  const [cancelEventForm] = Form.useForm();
  const [eventValues, setEventValues] = useState({});
  const [refetchFollowUpEventData, setRefetchFollowUpEventData] =
    useState(false);
  const [assignedToList, setAssignedToList] = useState([]);
  const [unresolvedModalVisible, setUnresolvedModalVisible] = useState(false);
  const [eventEmployeeId, setEventEmployeeId] = useState(null);
  const [eventAssignedToId, setEventAssignedToId] = useState(null);

  //Email Languages
  const [isEmailEnglishLanguages, setisEmailEnglishLanguages] = useState({
    pt: true,
    en: false,
  });
  //FirstMonthAssessment
  const [firstMonthAssessmentQuestions, setFirstMonthAssessmentQuestions] =
    useState([]);

  const [isEditEnabled, setIsEditEnabled] = useState(true);
  const [saveEditChanges, setSaveEditChanges] = useState(false);
  const [resignationReasonOptions, setResignationReasonOptions] = useState([]);

  const [settingADNProfileActive, setSettingADNProfileActive] = useState([]);
  const [settingProfileEmailActive, setSettingProfileEmailActive] = useState(
    []
  );
  const [
    settingFirstMonthAssessmentActive,
    setSettingFirstMonthAssessmentActive,
  ] = useState([]);
  const [settingIntergrationEmailActive, setSettingIntergrationEmailActive] =
    useState([]);

  const getSettingADNProfileActive = async () => {
    let settingId = "CF367BD3-9DC6-428B-A233-C44D76981741";
    getSetting(settingId).then((res) => {
      setSettingADNProfileActive(res.data);
    });
  };

  const getSettingProfileEmailActive = async () => {
    let settingId = "BCCD6F54-9EF7-4DED-8645-F2F02B67DC88";
    getSetting(settingId).then((res) => {
      setSettingProfileEmailActive(res.data);
    });
  };

  const getSettingFirstMonthAssessmentActive = async () => {
    let settingId = "E28D0977-A710-430C-AC44-902570294896";
    getSetting(settingId).then((res) => {
      setSettingFirstMonthAssessmentActive(res.data);
    });
  };

  const getSettingIntergrationEmailActive = async () => {
    let settingId = "0E65B49A-38CF-4410-AA74-EB716627B102";
    getSetting(settingId).then((res) => {
      setSettingIntergrationEmailActive(res.data);
    });
  };

  useEffect(() => {
    getSettingADNProfileActive();
    getSettingProfileEmailActive();
    getSettingFirstMonthAssessmentActive();
    getSettingIntergrationEmailActive();
  }, []);

  useEffect(() => {
    document.title = `${appTitle} - Consultant`;
    fetchAssignedToList();
    getResignationReasonsOptions();
    if (employeeId) {
      fetchCriticalSituations();
    }
    setIsEditEnabled(!employeeId);
  }, []);

  useEffect(() => {
    if (tagInputVisible) {
      tagInputRef.current?.focus();
    }
  }, [tagInputVisible]);

  useEffect(() => {
    tagEditInputRef.current?.focus();
  }, [tagInputValue]);

  useEffect(() => {
    let tecnologiesString = "";
    tags.forEach((tag) => {
      tecnologiesString += "#" + tag;
    });
    setTecnologiesString(tecnologiesString);
  }, [tags]);

  useEffect(() => {
    const getData = async () => {
        if ((employeeId.length == 36 && employeeId !== '00000000-0000-0000-0000-000000000000') || checkObjEmpty(params)) {
        await getUserById(getAuthenticatedUserId()).then((res) => {
          const NexelOrChiefIds = [1, 2, 3, 20];
          if (
            res.data.departmentId === Departement.Manager &&
            !NexelOrChiefIds.includes(res.data.positionId)
          ) {
            setIsManager(true);
          }
        });
        if ((employeeId.length == 36 && employeeId === '00000000-0000-0000-0000-000000000000') || checkObjEmpty(params)) {
          setPageHeader(t("manageEmployee.titles.newConsultant"));
          setLoadEditPreviewData(false);
          setIsSentInquiryEmail(false);
          setIsInquiryAnswered(false);
          setLoading(false);
        } else {
          setPageHeader(t("manageEmployee.titles.consultant"));
          setIsEditEnabled(false);
          setLoadEditPreviewData(true);
          await getEmployeeOffers();
        }
      } else {
        navigate(AppRoutes.consultantList.path);
        filterCareerLevelOptions();
      }

      await careerLevelOptions();

      await getWorkPlaces()
        .then((res) => {
          setWorkPlaceList(res.data);
        })
        .catch((err) => console.log(err));

      await getCountries()
        .then((res) => {
          setCountryList(res.data);
        })
        .catch((err) => console.log(err));

      await getContractTypes()
        .then((res) => {
          setContractTypeList(res.data);
        })
        .catch((err) => console.log(err));

      await getTechSpecialized()
        .then((res) => {
          setTechSpecializedList(res.data);
        })
        .catch((err) => console.log(err));

      await GetUserByDepartmentId(Departement.Manager).then((res) => {
        if (res.data) {
          setManagersList(res.data.result);
        }
      });

      await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
        if (res.data) {
          setHumanResList(res.data.result);
        }
      });

            await getDepartments().then((res) => {
                if (res.data) {
                    setDepartmentList(res.data);
                }
            });

            fetchTemplates();
        };

    getData();
  }, [employeeId]);

  useEffect(() => {
    if (isManager !== false) {
      const getEmployee = async () => {
        await checkIfEmployeeIsUnderManager(
          employeeId,
          getAuthenticatedUserId()
        ).then((res) => {
          if (res.data === true) {
            setManagerEditPermission(true);
          } else {
            setManagerEditPermission(false);
          }
        });
      };
      getEmployee();
    }
  }, [isManager]);

  useEffect(() => {
    fetchTemplates();
  }, [isEmailEnglishLanguages]);

  const fetchTemplates = async () => {
    await getTemplates().then((res) => {
      if (res.data) {
        if (isEmailEnglishLanguages.pt === true) {
          setTemplates([
            res.data[0],
            res.data[1],
            res.data[2],
            res.data[3],
            res.data[4],
          ]);
          setisEmailEnglishLanguage(0);
        } else {
          setTemplates([
            res.data[5],
            res.data[6],
            res.data[7],
            res.data[8],
            res.data[9],
          ]);
          setisEmailEnglishLanguage(1);
        }
      }
    });
  };

  useEffect(() => {
    getEmployeeFollowUpEvent();
  }, [
    orderByFollowUp,
    currentPageFollowUp,
    refetchFollowUpEventData,
    employeeId,
  ]);

  useEffect(() => {
    const getEmployeeCertifications = async () => {
      await getEmployeeCertificationByEmployeeId(employeeId, "", 1).then(
        (res) => {
          if (res.data.result != null) {
            res.data.result.forEach((e) => {
              e.date =
                e.date == null
                  ? undefined
                  : JSON.stringify(e.date).substring(1, 11);
            });
            setEmployeeCertificationData(res.data.result);
            setTotalRecordsEmployeeCertification(res.data.totalRecords);
          }
        }
      );
    };

    getEmployeeCertifications();
  }, [employeeId]);

  useEffect(() => {
    setPageHeader(
      isEditEnabled
        ? t("manageEmployee.titles.editConsultant")
        : t("manageEmployee.titles.consultant")
    );
  }, [isEditEnabled]);

  useEffect(() => {
    let finalPercentage = 0;
    let count = 0;
    let numberOfEvents = 1;
    if (settingADNProfileActive.value === "TRUE") numberOfEvents++;
    if (settingFirstMonthAssessmentActive.value === "TRUE") numberOfEvents++;
    if (settingIntergrationEmailActive.value === "TRUE") numberOfEvents++;
    if (settingProfileEmailActive.value === "TRUE") numberOfEvents++;

    getEmployeeById(employeeId).then((res) => {
      if (res.data.title === "Not Found")
        return navigate(AppRoutes.notFound.path);
      if (res.data.hasAssessmentSent) count++;
      if (res.data.hasIntegrationEmailSent === 1) count++;
      if (res.data.hasInquirySent) count++;
      if (res.data.hasProfileEmailSent) count++;
      if (res.data.hasCorpDone) count++;
      finalPercentage = (count / numberOfEvents) * 100;
      setPercentage(finalPercentage);
    });
  }, [
    isFirstMonthAssessmentEmailSent,
    isIntegrationEmailSent,
    isSentInquiryEmail,
    isProfileEmailSent,
    percentage,
  ]);

  useEffect(() => {
    if (loadEditPreviewData) {
      const fetchArray = async () => {
        await getEmployeeImageById(employeeId).then((res) => {
          setImage(res.data.image);
        });

        await getEmployeeById(employeeId).then(async (res) => {
          if (res.data.title === "Not Found")
            return navigate(AppRoutes.notFound.path);

          if (res.data.admissionCtiDate != null) {
            setHaveAdmissionCti(true);
          }

          //comparar se o manager logado é o mesmo que o manager do consultor senão navigate to fobidden page
          if (res.status === 200) {
            if (res.data.hasInquirySent && res.data.inquiryToken != null) {
              setIsSentInquiryEmail(true);
            }
            if (res.data.hasInquirySent && res.data.inquiryToken == null) {
              setIsInquiryAnswered(true);
            }
            if (res.data.hasAssessmentSent) {
              setIsFirstMonthAssessmentEmailSent(true);
            }

            if (
              res.data.hasAssessmentSent &&
              res.data.assessmentToken == null
            ) {
              setIsFirstMonthAssessmentAnswered(true);
            }

            setIsConsultant(res.data.isConsultant);

            if (res.data.contractTypeId === ContractType.CPS)
              setHaveAdmissionCps(true);

            if (
              (res.data.contractTypeId === ContractType.CTI || res.data.contractTypeId === ContractType.Indefinido) &&
              res.data.admissionDate != null
            ) {
              setIsCTI(true);
            }
            if (res.data.hasIntegrationEmailSent === 1) {
              setIsIntegrationEmailSent(1);
            }
            if (res.data.hasIntegrationEmailSent === 2) {
              setIsIntegrationEmailSent(0);
            }
            if (res.data.hasProfileEmailSent) {
              setIsProfileEmailSent(true);
            }

            setInitValues({
              name: res.data.name,
              email: res.data.email,
              number: res.data.number,
              birthDate: res.data.birthDate ? moment(res.data.birthDate) : "",
              admissionDate: res.data.admissionDate
                ? moment(res.data.admissionDate)
                : "",
              admissionCtiDate: res.data.admissionCtiDate
                ? moment(res.data.admissionCtiDate)
                : "",
              availableDate: res.data.availableDate
                ? moment(res.data.availableDate)
                : "",
              resignationDate: res.data.resignationDate
                ? moment(res.data.resignationDate)
                : "",
              resignationReasonId: res.data.resignationReasonId,
              dismissalComment: res.data.dismissalComment,
              dismissalReasonCode: res.data.dismissalReasonCode,
              departureReason: res.data.departureReason,
              hasCorpDone: res.data.hasCorpDone,
              hasIntegrationEmailSent: res.data.hasIntegrationEmailSent,
              hasProfileEmailSent: res.data.hasProfileEmailSent,
              hasInquirySent: res.data.hasInquirySent,
              hasAssessmentSent: res.data.hasAssessmentSent,
              assessmentToken: res.data.assessmentToken,
              placeOfBirth: res.data.placeOfBirth,
              professionalResume: res.data.professionalResume,
              note: res.data.note,
              question1: res.data.question1,
              question2: res.data.question2,
              question3: res.data.question3,
              question4: res.data.question4,
              question5: res.data.question5,
              question6: res.data.question6,
              response1: res.data.response1,
              response2: res.data.response2,
              response3: res.data.response3,
              response4: res.data.response4,
              response5: res.data.response5,
              response6: res.data.response6,
              inquiryToken: res.data.inquiryToken,
              contractTypeId: res.data.contractTypeId,
              currentCompany: res.data.currentCompany,
              carrearLevelId: res.data.carrearLevelId,
              managerId: res.data.managerId,
              techSpecializedId: res.data.techSpecializedId,
              workPlaceId: res.data.workPlaceId,
              nationalityId: res.data.nationalityId,
              isEmailEnglishLanguage: res.data.isEmailEnglishLanguage,
              gender: res.data.gender,
              phone: res.data.phone,
              invalidPhone: res.data.invalidPhone,
              phone2: res.data.phone2,
              tecnologies: res.data.tecnologies,
              referenceByName: res.data.referenceByName,
              referenceById: res.data.referenceById,
              inTransition: res.data.inTransition,
              departmentId: res.data.departmentId,
            });
            hasResignationDateValue(res.data.resignationDate);
            hasCorpDepartureReasonValue(res.data.departureReason);
            setInitialisEmailEnglishLanguage(res.data.isEmailEnglishLanguage);
            setTags(res.data.tecnologies);
            setReferenceByName(res.data.referenceByName);
            setSearchReferenceBy(res.data.referenceByName);
            setReferenceById(res.data.referenceById);
            setInTransition(res.data.inTransition);

            if (res.data.languages != null) {
              let myArray = res.data.languages.split(",");
              myArray.forEach((x) => {
                if (x === "PT") {
                  fluencyLanguages.pt = true;
                }
                if (x === "EN") {
                  fluencyLanguages.en = true;
                }
                if (x === "ES") {
                  fluencyLanguages.es = true;
                }
                if (x === "FR") {
                  fluencyLanguages.fr = true;
                }
                if (x === "IT") {
                  fluencyLanguages.it = true;
                }
                if (x === "GR") {
                  fluencyLanguages.gr = true;
                }
                if (x === "GE") {
                  fluencyLanguages.ge = true;
                }
              });
            }

            await getContractTypes().then((result) => {
              if (res.data.contractTypeId === ContractType.Academy) {
                setContractTypeList(
                  result.data.filter((x) => x.id !== 2 && x.id !== 3)
                );
              } else if (res.data.contractTypeId === ContractType.CPS) {
                setContractTypeList(
                  result.data.filter((x) => x.id !== 4 && x.id !== 3)
                );
              } else if (res.data.contractTypeId === ContractType.CTC) {
                setContractTypeList(result.data.filter((x) => x.id === 3));
              } else if (res.data.contractTypeId === 1) {
                setContractTypeList(result.data.filter((x) => x.id === 1)); // Verificar com André
              } else {
                setContractTypeList(result.data);
              }
            });
          }
        });
      };

      fetchArray();
      setLoading(false);
    }
  }, [loadEditPreviewData, refreshData, employeeId]);

  //load templates only if newConsultant situation
  useEffect(() => {
    const getQuestions = async () => {
      if (selectedTemplateId > 0) {
        await getTemplateQuestions(selectedTemplateId).then((res) => {
          //Verify if null
          if (res.status === 200) {
            setTemplateQuestions((prev) => {
              let arr = [...prev];
              arr[selectedTemplateId - 1] = res.data;
              return arr;
            });
            onQuestion1Change(res.data[0].question);
            onQuestion2Change(res.data[1].question);
            onQuestion3Change(res.data[2].question);
            onQuestion4Change(res.data[3].question);
            onQuestion5Change(res.data[4].question);
            onQuestion6Change(res.data[5].question);
          }
        });
      }
    };

    getQuestions();
  }, [selectedTemplateId]);

  useEffect(() => {
    consultantForm.resetFields();
    inquiryForm.resetFields();
  }, [initValues]);

  useEffect(() => {
    loadEmployeeFollowUpEventsCounters();
    loadEmployeeOffersCounters();
    loadEmployeesSatisfaction();
    filterCareerLevelOptions();
  }, [employeeFollowUpEventData, employeeOfferData]);

  useEffect(() => {
    if (employeeId != null) {
      fetchFirstMonthAssessmentQuestions(employeeId);
    }
  }, [employeeId]);

  const fetchFirstMonthAssessmentQuestions = async (id) => {
    await getFirstMonthAssessmentQuestionsByEmployeeId(id).then((res) => {
      setFirstMonthAssessmentQuestions(res.data);
    });
  };

  const getEmployeeFollowUpEvent = async () => {
    await getFollowUpEventByEmployeeId(
      employeeId,
      orderByFollowUp,
      currentPageFollowUp,
      adnPageSize
    ).then((res) => {
      if (res.data.result != null) {
        res.data.result.forEach((e) => {
          e.date =
            e.date === null
              ? undefined
              : JSON.stringify(e.date).substring(1, 11);
        });
        setEmployeeFollowUpEventData(res.data.result);
        setTotalRecordsFollowUp(res.data.totalRecords);
      }
    });
  };

  const setInitialisEmailEnglishLanguage = (data) => {
    if (data) {
      setisEmailEnglishLanguages(() => ({ pt: false, en: true }));
    }
  };

  const loadEmployeesSatisfaction = async () => {
    await getEmployeesSatisfactionLevels(employeeId).then((res) => {
      if (res.status === 200) {
        setCompanySatisfaction(res.data.companySatisfaction);
        setProjectSatisfaction(res.data.projectSatisfaction);
        setClientSatisfaction(res.data.clientSatisfaction);
      }
    });
  };

  const fetchCriticalSituations = () => {
    getCriticalSituations({
      pageNumber: 1,
      pageSize: 2,
      employeeId,
      statusId: CriticalSituationStatus.FollowingUp,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.result.length === 0) {
            setCriticalSituationsLinkPath(undefined);
          } else if (res.data.result.length === 1) {
            setCriticalSituationsLinkPath(
              AppRoutes.criticalSituationById.createPath(res.data.result[0].id)
            );
          } else {
            setCriticalSituationsLinkPath(
              `${AppRoutes.criticalSituationsList.path}?employeeId=${employeeId}`
            );
          }
        } else {
          AdnMessageError(
            t("manageEmployee.messages.couldNotGetCriticalSituations")
          );
        }
      })
      .catch(() =>
        AdnMessageError(
          t("manageEmployee.messages.couldNotGetCriticalSituations")
        )
      );
  };

  const loadEmployeeOffersCounters = async () => {
    await getEmployeeOffersCounters(employeeId).then((res) => {
      if (res.status === 200) {
        setEmployeeOffersCounters(res.data);
      }
    });
  };

  const loadEmployeeFollowUpEventsCounters = async () => {
    await getEmployeeFollowUpEventsCounters(employeeId).then((res) => {
      if (res.status === 200) {
        setEmployeeFollowUpEventsCounters(res.data);
      }
    });
  };

  const getEmployeeContractHistoryInfo = async () => {
    await getEmployeeContractHistory(employeeId)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeContractHistory(res.data);
          setShowContractHistoryModal(true);
        } else {
          setEmployeeContractHistory([]);
          setShowContractHistoryModal(false);
          const errors = res.data.errors;
          errors.forEach((error) => {
            const errorMessage = error.message;
            AdnMessageError(errorMessage);
          });
        }
      })
      .catch((err) => {
        setEmployeeContractHistory([]);
        setShowContractHistoryModal(false);
        AdnMessageError();
      });
  };

  const followUpEventsProgressConfig = {
    height: 125,
    width: 125,
    autoFit: false,
    percent:
      employeeFollowUpEventsCounters &&
      employeeFollowUpEventsCounters.employeeFollowUpEventDone !== 0
        ? employeeFollowUpEventsCounters.employeeFollowUpEventDone /
          (employeeFollowUpEventsCounters.employeeFollowUpEventUndone +
            employeeFollowUpEventsCounters.employeeFollowUpEventDone)
        : 0,

    color: ["#7d6ef9", "#E8EDF3"],
    innerRadius: 0.85,
    radius: 0.98,
    statistic: {
      title: {
        style: {
          color: "#363636",
          fontSize: "12px",
          lineHeight: "14px",
          cursor: "pointer",
        },
        formatter: () =>
          `${
            employeeFollowUpEventsCounters
              ? employeeFollowUpEventsCounters.employeeFollowUpEventDone
              : 0
          } out of
      ${
        employeeFollowUpEventsCounters
          ? employeeFollowUpEventsCounters.employeeFollowUpEventDone +
            employeeFollowUpEventsCounters.employeeFollowUpEventUndone
          : 0
      }`,
      },
    },
  };

  const offersProgressConfig = {
    height: 125,
    width: 125,
    autoFit: false,
    percent:
      employeeOffersCounters && employeeOffersCounters.employeeOffersGiven !== 0
        ? employeeOffersCounters.employeeOffersGiven /
          (employeeOffersCounters.employeeOffersForGiving +
            employeeOffersCounters.employeeOffersGiven)
        : 0,
    color: ["#f6c022", "#E8EDF3"],
    innerRadius: 0.85,
    radius: 0.98,
    statistic: {
      title: {
        style: {
          color: "#363636",
          fontSize: "12px",
          lineHeight: "14px",
        },
        formatter: () =>
          `${
            employeeOffersCounters
              ? employeeOffersCounters.employeeOffersGiven
              : 0
          } out of
      ${
        employeeOffersCounters
          ? employeeOffersCounters.employeeOffersGiven +
            employeeOffersCounters.employeeOffersForGiving
          : 0
      }`,
      },
    },
  };

  const filterCareerLevelOptions = (data = careerLevels) => {
    setAvailableCareerLevels(
      data.filter((level) => {
        if (
          consultantForm.getFieldValue("contractTypeId") !== academyContractId
        )
          return level;
        else return level.name === "Trainee";
      })
    );
  };

  useEffect(() => {
    filterCareerLevelOptions(careerLevels);
  }, [careerLevels]);

  const careerLevelOptions = async () => {
    await getCareerLevels().then((res) => {
      setCareerLevels(res.data);
    });
  };

  const getResignationReasonsOptions = async () => {
    await getResignationReasons().then((res) => {
      setResignationReasonOptions(res.data);
    });
  };

  // When contract type changes, check available levels
  const handleContractType = async (contractTypeId) => {
    if (contractTypeId !== academyContractId) {
      consultantForm.setFieldsValue({ carrearLevelId: null });
    } else {
      consultantForm.setFieldsValue({
        carrearLevelId: careerLevels.filter(
          (level) => level.name === "Trainee"
        )[0].id,
      });
    }
  };

  const handleTransition = async () => {
    if (initValues?.inTransition === false) {
      setInTransition(true);
    }
  };

  //On Template Selected Change
  const onTemplateChangeHandle = async (value) => {
    setSelectedTemplateId(value);
  };

  const calculateValue = (date, currentDate) => {
    let day = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let dateMonth = date.month() + 1;
    let dateDay = date.date();
    return month > dateMonth || (month === dateMonth && day > dateDay);
  };

  const EmployeeDetails = (values) => {
    const current = new Date();
    let year = current.getFullYear().toString();
    let emailValueBirth = calculateValue(values.birthDate, current);
    let emailValueAntiquity = calculateValue(values.admissionDate, current);

        let employeeDetails = {
            authenticatedId: '00000000-0000-0000-0000-000000000000',
            name: values.name,
            number: values.number,
            contractTypeId: values.contractTypeId,
            birthDate: moment(values.birthDate).format("YYYY-MM-DDTHH:mm:ss"),
            email: values.email,
            gender: values.gender,
            nationalityId: values.nationalityId,
            isEmailEnglishLanguage: isEmailEnglishLanguages.en || false,
            lastBirthdayEmailSentYear: emailValueBirth ? year : null,
            lastAntiquityEmailSentYear: emailValueAntiquity ? year : null,
            managerId: values.managerId,
            availableDate: values.availableDate
                ? moment(values.availableDate).format("YYYY-MM-DDTHH:mm:ss")
                : null,
            admissionDate: moment(values.admissionDate).format("YYYY-MM-DDTHH:mm:ss"),
            admissionCtiDate: values.admissionCtiDate
                ? moment(values.admissionCtiDate).format("YYYY-MM-DDTHH:mm:ss")
                : null,
            resignationDate: values.resignationDate
                ? moment(values.resignationDate).format("YYYY-MM-DDTHH:mm:ss")
                : null,
            resignationReasonId: values.resignationReasonId,
            dismissalComment: values.dismissalComment,
            dismissalReasonCode: values.dismissalReasonCode,
            workPlaceId: values.workPlaceId,
            phone: values.phone,
            phone2: values.phone2,
            carrearLevelId: values.carrearLevelId,
            hasIntegrationEmailSent: isIntegrationEmailSent || 0,
            hasProfileEmailSent: isProfileEmailSent || false,
            hasCorpDone: values.hasCorpDone || false,
            hasInquirySent: isSentInquiryEmail,
            isConsultant: values.isConsultant,
            note: values.note || "",
            templateId: values.templateId,
            question1: values.question1,
            question2: values.question2,
            question3: values.question3,
            question4: values.question4,
            question5: values.question5,
            question6: values.question6,
            tecnologies: tags,
            referenceById: referenceById,
            currentCompany: values.currentCompany,
            departmentId: values.departmentId ? values.departmentId : null
        };

    return employeeDetails;
  };

  const onFormFinish = async (values) => {
    setSaveEditChanges(false);
    isConsultant ? (values.isConsultant = true) : (values.isConsultant = false);
    setSubmitLoading(true);

    let employeeDetails = EmployeeDetails({
      ...values,
    });
    employeeDetails.inTransition = inTransition;

    if (loadEditPreviewData) {
      employeeDetails.id = employeeId;

      if (
        employeeDetails.departmentId === Departement.NeXel ||
        employeeDetails.departmentId === Departement.NoDepartment
      ) {
        employeeDetails.inTransition = true;
      }

      await updateEmployee(employeeDetails)
        .then(async (res) => {
          setSubmitLoading(false);
          if (res.status === 201 && res.data.success) {
            AdnMessageSuccess();
            const isResigned = handleCheckIfResigned(employeeDetails);
            if (isResigned) {
              const benefits = await handleCheckUnpaidBenefits(
                employeeDetails.id
              );
              if (benefits.length !== 0) {
                setVisibleCancelRecommendationsModal(true);
              }
            }
            setRefreshData(!refreshData);
            setIsEditEnabled(false);
            navigate(AppRoutes.consultantById.createPath(employeeId));
          } else {
            const errors = res.data.errors;

            errors.forEach((error) => {
              const errorMessage = error.message;
              AdnMessageError(errorMessage);
            });
          }
        })
        .catch((err) => {
          AdnMessageError();
        });
    } else {
      await addEmployee(employeeDetails)
        .then((res) => {
          setSubmitLoading(false);
          if (res.status === 201) {
            AdnMessageSuccess();
            setPageHeader(t("manageEmployee.titles.editConsultant"));
            navigate(AppRoutes.consultantById.createPath(res.data.id));
          } else {
            const errors = res.data.errors;

            errors.forEach((error) => {
              const errorMessage = error.message;
              AdnMessageError(errorMessage);
            });
          }
        })
        .catch((err) => {
          AdnMessageError(err);
        });
    }
  };

  const handleCheckIfResigned = (employeeDetails) => {
    return (
      employeeDetails.resignationDate !== null &&
      employeeDetails.resignationDate !== initValues.resignationDate._i
    );
  };

  const handleCheckUnpaidBenefits = async (id) => {
    let unpaidBenefits = [];
    await getEmployeeRecommendationBenefitsByEmployeeId(id).then((res) => {
      unpaidBenefits = res.data;
    });
    return unpaidBenefits;
  };

  const handleCancelUnpaidRecommendations = async () => {
    const request = {};
    request.employeeId = employeeId;
    await updateCanceledEmployeeRecommendationBenefits(request).then((res) => {
      if (res.status === 200) {
        AdnMessageSuccess();
      } else AdnMessageError(t("manageEmployee.messages.couldntCancelAwards"));
    });
    setVisibleCancelRecommendationsModal(false);
  };

  const getEmployeeOffers = async () => {
    await getEmployeeOfferByEmployeeList(employeeId).then((result) => {
      let offers = result.data;

      offers.forEach((offer) => {
        if (offer != null) {
          if (offer.offeredAt == null) {
            offer.offeredAt = undefined;
          } else {
            offer.offeredAt = moment(offer.offeredAt).format(dateFormat);
          }
        }
      });

      formOffers.setFieldsValue({ ...offers });
      setEmployeeOfferData(offers);
    });
  };

  const getOfferListData = async () => {
    const res = await getOfferLists();
    const offersList = res.data;

    const filteredOffers = offersList.filter((k) => {
      let flag = true;
      employeeOfferData.forEach((x) => {
        if (k.id === 1) {
          flag = false;
        }
      });
      return flag;
    });

    setOfferData(filteredOffers);
  };

  const ShowEditModal = (record) => {
    if (record.offeredAt == null) {
      record.offeredAt = null;
    } else {
      record.offeredAt = moment(record.offeredAt, dateFormat);
    }

    formOffers.setFieldsValue({ ...record });
    setOfferHandler({ ...record });
    setVisibleModalOffer(true);
    setEvent("Edit");
  };

  const handleFormOffer = async (values) => {
    if (event === "Add") {
      values.status = 0;
      values.employeeId = employeeId;
      values.referenceDate = moment(moment());
      values.offeredAt = values.offeredAt || null;
      await addEmployeeOffer(values)
        .then(async (res) => {
          setModalSubmitLoading(true);
          if (res.data.success === true) {
            await getEmployeeOffers();

            setVisibleModalOffer(false);
            AdnMessageSuccess();
          } else {
            AdnMessageError(res.data.errors[0].message);
          }
        })
        .catch((error) => {
          AdnMessageError(error.message);
        })
        .finally(() => {
          setModalSubmitLoading(false);
          setVisibleModalOffer(false);
        });
    } else if (event === "Edit") {
      values.status = 1;
      values.id = offerHandler.id;
      values.employeeId = employeeId;
      await updateEmployeeOffer(values)
        .then(async (res) => {
          setModalSubmitLoading(true);
          if (res.data.success === true) {
            await getEmployeeOffers();

            AdnMessageSuccess();
          } else {
            AdnMessageError(res.data.errors[0].message);
          }
        })
        .catch((error) => {
          AdnMessageError(error.message);
        })
        .finally(() => {
          setModalSubmitLoading(false);
          setVisibleModalOffer(false);
        });
    }
  };

  const onQuestion1Change = (value) => {
    consultantForm.setFieldsValue({ question1: value });
  };

  const onQuestion2Change = (value) => {
    consultantForm.setFieldsValue({ question2: value });
  };

  const onQuestion3Change = (value) => {
    consultantForm.setFieldsValue({ question3: value });
  };

  const onQuestion4Change = (value) => {
    consultantForm.setFieldsValue({ question4: value });
  };

  const onQuestion5Change = (value) => {
    consultantForm.setFieldsValue({ question5: value });
  };

  const onQuestion6Change = (value) => {
    consultantForm.setFieldsValue({ question6: value });
  };

  const submitInquiry = async (values) => {
    const filteredLanguages = Object.keys(fluencyLanguages).filter(
      (key) => fluencyLanguages[key]
    );
    values.languages = filteredLanguages.join(",");

    values.id = employeeId;
    await updateEmployeeInquiryResponses(values).then((res) => {
      if (res.status === 200 && res.data.success) {
        AdnMessageSuccess();
      } else {
        AdnMessageError(res.data.errors[0].message);
      }
    });
  };

  const sendInquiryEmail = async () => {
    setIsEmailSending(true);
    const inquiry = {};
    inquiry.id = employeeId;
    inquiry.hasInquirySent = null;
    inquiry.inquiryToken = null;

    inquiry.question1 = consultantForm.getFieldValue("question1");
    inquiry.question2 = consultantForm.getFieldValue("question2");
    inquiry.question3 = consultantForm.getFieldValue("question3");
    inquiry.question4 = consultantForm.getFieldValue("question4");
    inquiry.question5 = consultantForm.getFieldValue("question5");
    inquiry.question6 = consultantForm.getFieldValue("question6");
    inquiry.languages = null;
    inquiry.placeOfBirth = null;
    inquiry.professionalResume = null;

    await updateInquiry(inquiry)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setVisibleModalEmail(false);
          setIsSentInquiryEmail(true);
          AdnMessageSuccess(t("manageEmployee.messages.emailSent"));
          formEmail.resetFields();
        } else if (res?.data && res.data?.errors) {
          res.data.errors.forEach((e) => {
            AdnMessageError(e.message);
          });
        } else {
          AdnMessageError(t("manageEmployee.messages.couldNotSendEmail"));
        }
        setIsEmailSending(false);
        setEmailSubmitLoading(false);
      })
      .catch(() => {
        AdnMessageError(t("manageEmployee.messages.couldNotSendEmail"));
      });
  };

  const disabledDateOffer = (current) => {
    if (
      moment().year() < current.year() ||
      moment().year() - current.year() > 1
    )
      return true;

    if (moment().year() - current.year() <= 0) {
      if (moment().month() < current.month()) return true;

      if (moment().month() === current.month()) {
        if (moment().date() < current.date()) return true;
      }
    }
    return false;
  };

  const [hasResignationDate, setHasResignationDate] = useState(false);
  const hasResignationDateValue = (resignationDate) => {
    const has =
      resignationDate !== "" &&
      resignationDate !== null &&
      resignationDate !== undefined;
    setHasResignationDate(has || false);
    return has || false;
  };
  const handleResignationDateChange = (date) => {
    const show = hasResignationDateValue(date);
    if (show === false) {
      consultantForm.setFieldValue("resignationReasonId", undefined);
    }
  };

  const [hasCorpDepartureReason, sethasCorpDepartureReason] = useState(false);
  const hasCorpDepartureReasonValue = (departureReason) => {
    const has =
      departureReason !== "" &&
      departureReason !== null &&
      departureReason !== undefined;
    sethasCorpDepartureReason(has || false);
    return has || false;
  };

  const disabledDateBirthDate = (current) => {
    if (
      moment().year() - current.year() < 18 ||
      moment().year() - current.year() > 120
    )
      return true;

    if (moment().year() - current.year() === 18) {
      if (moment().month() < current.month()) return true;

      if (moment().month() === current.month()) {
        if (moment().date() < current.date()) return true;
      }
    }
    return false;
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const saveImage = async (img) => {
    setImgLoading(true);
    let myFormData = new FormData();
    myFormData.append("Image", img);
    myFormData.append("Id", employeeId);
    const res = await updateEmployeeImage(myFormData);
    setImgLoading(false);
    if (res.status !== 200) {
      AdnMessageError(t("manageEmployee.messages.failToUploadPhoto"));
      return;
    }
    getBase64(img, setImage);
  };

  const handleBlurName = () => {
    const name = consultantForm
      .getFieldValue("name")
      ?.trim()
      .split(/\s+/)
      .filter((w) => w !== "")
      .map(
        ([firstChar, ...rest]) =>
          firstChar.toUpperCase() + rest.join("").toLowerCase()
      )
      .join(" ");

    consultantForm.setFieldsValue({ name: name });
    consultantForm.validateFields(["name"]).then(async () => {
      await getEmployees(1, 1, "name", name, "", "", true).then((res) => {
        const employeesNumber =
          pageHeader === t("manageEmployee.titles.newConsultant") ? 0 : 1;
        if (res.data.totalRecords > employeesNumber) {
          consultantForm.setFields([
            {
              name: "name",
              warnings: [t("manageEmployee.warnings.nameAlreadyExists")],
            },
          ]);
        }
      });
    });
  };

  const handleBlurEmail = () => {
    const email = consultantForm.getFieldValue("email")?.trim().toLowerCase();
    consultantForm.setFieldsValue({ email: email });
    consultantForm.validateFields(["email"]).then(async () => {
      await getEmployees(1, 1, "email", "", email, "", "", "", true).then(
        (res) => {
          const employeesNumber =
            pageHeader === t("manageEmployee.titles.newConsultant") ? 0 : 1;
          if (res.data.totalRecords > employeesNumber) {
            consultantForm.setFields([
              {
                name: "email",
                warnings: [t("manageEmployee.warnings.emailAlreadyExists")],
              },
            ]);
          }
        }
      );
    });
  };

  const fetchAssignedToList = async () => {
    let HRArray = [];
    let ManagerArray = [];

    await GetUserByDepartmentId(Departement.Manager).then((res) => {
      if (res.status === 200) {
        ManagerArray = res.data.result;
      } else {
        AdnMessageError(t("manageEmployee.messages.errorLoadingManagersList"));
      }
    });

    await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
      if (res.status === 200) {
        HRArray = res.data.result;
      } else {
        AdnMessageError(t("manageEmployee.messages.errorLoadingHRList"));
      }
    });
    setAssignedToList(HRArray.concat(ManagerArray));
  };

  const handleAssignPerson = async (employeeFollowUpEventId, assignedToId) => {
    setEventEmployeeId(employeeFollowUpEventId);
    setEventAssignedToId(assignedToId);

    await checkPreviousUnresolvedEmployeeFollowUpEventsById(
      employeeFollowUpEventId
    ).then(async (res) => {
      if (res.status === 200) {
        if (res.data && res.data.listOfEvents.length > 0) {
          setUnresolvedModalVisible(true);
        } else {
          confirmAssignPerson(employeeFollowUpEventId, assignedToId);
        }
      }
    });
  };

  const confirmAssignPerson = async (employeeFollowUpEventId, assignedToId) => {
    await getEmployeeFollowUpEventById(employeeFollowUpEventId).then((res) => {
      if (res.status === 200) {
        res.data.doneById = assignedToId;
        if (assignedToId != null) {
          res.data.status = 1;
        } else {
          res.data.status = 0;
        }
        setEventValues(res.data);
      }
    });
  };

  const onCancelOffersModal = () => {
    if (searchParams.get("offer")) {
      navigate(-1);
    }
    setVisibleModalOffer(false);
  };

  const handleOfferDate = async (offerDate, offerData) => {
    if (offerDate != null) {
      let updatedOffer = {
        status: 1,
        id: offerData.id,
        employeeId: offerData.employeeId,
        typeId: offerData.typeId,
        offeredAt: offerDate,
        note: offerData.note,
        offerName: offerData.offerName,
        referenceDate: offerData.referenceDate,
        description: offerData.description,
      };
      await updateEmployeeOffer(updatedOffer).then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess();
          getEmployeeOffers();
        } else {
          AdnMessageError(t("manageEmployee.messages.couldntUpdateOffer"));
        }
      });
    }
  };

  const handleCancelOfferModal = (values) => {
    setOfferFormValues(values);
    setCancelOfferVisible(true);
  };

  const handleChangeOffer = async (values, status) => {
    let canceledOffer = {
      id: values.id,
      employeeId: values.employeeId,
      typeId: values.typeId,
      offeredAt: status === 0 ? null : values.offeredAt,
      note: status === 0 ? "" : cancelOfferForm.getFieldValue("note"),
      offerName: values.offerName,
      referenceDate: values.referenceDate ? values.referenceDate : null,
      description: values.description,
      status: status,
    };

    await updateEmployeeOffer(canceledOffer).then(async (res) => {
      if (res.status === 200) {
        AdnMessageSuccess();
        await getEmployeeOffers();
        setCancelOfferVisible(false);
      } else {
        AdnMessageError(t("manageEmployee.messages.couldntChangeOfferStatus"));
      }
    });
  };

  const handleChangeToCti = (id) => {
    if (id === parseInt(contractTypeList[0].id) && loadEditPreviewData) {
      setHaveAdmissionCti(true);
      setHaveAdmissionCps(false);
    } else if (id === parseInt(contractTypeList[1].id)) {
      setHaveAdmissionCps(true);
      setHaveAdmissionCti(false);
    } else {
      setHaveAdmissionCti(false);
      setHaveAdmissionCps(false);
    }
  };

  const handleChangeTechSpecializedName = (value) => {
    if (value && techSpecializedList.length > 0) {
      setTechSpecializedName(
        techSpecializedList.filter((x) => x.id === value)[0].name
      );
    }
  };

  const onIsConsultantChange = (value) => {
    if (value === "consultant") {
      setIsConsultant(true);
    } else if (value === "internal") {
      setIsConsultant(false);
    }
  };

  const sendProfileEmail = async () => {
    setIsEmailSending(true);
    await updateProfileEmail({ id: employeeId }).then((res) => {
      if (res.status === 200) {
        setVisibleModalEmail(false);
        setIsProfileEmailSent(true);
        AdnMessageSuccess(t("manageEmployee.messages.emailSentSuccess"));
        formEmail.resetFields();
      } else {
        if (res.status === 400)
          adnNotification(t("manageEmployee.messages.couldNotSendEmail"));
        else AdnMessageError();
      }
      setIsEmailSending(false);
      setEmailSubmitLoading(false);
    });
  };

  const sendIntegrationEmail = async () => {
    setIsEmailSending(true);
    await updateIntegration({ id: employeeId }).then((res) => {
      if (res.status === 200) {
        setVisibleModalEmail(false);
        setIsIntegrationEmailSent(1);
        AdnMessageSuccess(t("manageEmployee.messages.emailSentSuccess"));
        formEmail.resetFields();
      } else {
        if (res.status === 400)
          adnNotification(t("manageEmployee.messages.couldNotSendEmail"));
        else AdnMessageError();
      }
      setIsEmailSending(false);
      setEmailSubmitLoading(false);
    });
  };

  const sendFirstMonthAssessmentEmail = async () => {
    setIsEmailSending(true);
    await updateFirstMonthAssessmentEmail({
      id: employeeId,
      questionType: 2,
    }).then((res) => {
      if (res.status === 200) {
        setVisibleModalEmail(false);
        setIsFirstMonthAssessmentEmailSent(true);
        AdnMessageSuccess(t("manageEmployee.messages.emailSentSuccess"));
        formEmail.resetFields();
        getEmployeeFollowUpEvent();
      } else {
        if (res.status === 400)
          adnNotification(t("manageEmployee.messages.couldNotSendEmail"));
        else AdnMessageError();
      }
      setIsEmailSending(false);
      setEmailSubmitLoading(false);
    });
  };

  const openEmailModal = (type) => {
    handleFormEmail(type);
  };

  const handleFormEmail = (type) => {
    setEmailSubmitLoading(true);
    if (type === "Profile") sendProfileEmail();
    if (type === "ADNProfile") sendInquiryEmail();
    if (type === "FirstMonthAssessment") sendFirstMonthAssessmentEmail();
    if (type === "Integration") sendIntegrationEmail();
  };

  const onCancelEmailModal = () => {
    setVisibleModalEmail(false);
    formEmail.resetFields();
  };

  const referenceByBlur = () => {
    if (
      referenceByName !== initValues?.referenceBy &&
      referenceByName.toLowerCase() !==
        referenceByEmployees[0]?.name.toLowerCase()
    ) {
      setReferenceByName("");
    }
  };

  const handleSelectReferenceBy = (name) => {
    setReferenceByName(name);
    setSearchReferenceBy(name);
  };

  const handleSearchReferenceBy = (name) => {
    setReferenceByName(name);
    name.length >= 3 ? setSearchReferenceBy(name) : setSearchReferenceBy("");
  };

  const handleCloseTag = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  const showTagInput = () => {
    setTagInputVisible(true);
  };

  const handleTagInputChange = (e) => {
    setTagInputValue(e.target.value);
  };

  const handleTagInputConfirm = () => {
    if (tagInputValue && tags.indexOf(tagInputValue) === -1) {
      setTags([...tags, tagInputValue]);
    }

    setTagInputVisible(false);
    setTagInputValue("");
  };

  const handleTagEditInputChange = (e) => {
    setTagEditInputValue(e.target.value);
  };

  const handleTagEditInputConfirm = () => {
    const newTags = [...tags];
    newTags[editTagInputIndex] = editTagInputValue;
    setTags(newTags);
    setTagEditInputIndex(-1);
    setTagInputValue("");
  };

  const disableEdit = () => {
    setSaveEditChanges(true);
  };

  const handleCancelEventModal = (values) => {
    setEventFormValues(values);
    setCancelEventVisible(true);
  };

  const handleUnCancelEvent = async (employeeFollowUpEventId) => {
    await getEmployeeFollowUpEventById(employeeFollowUpEventId).then((res) => {
      if (res.status === 200) {
        res.data.status = 0;
        res.data.doneById = null;
        res.data.date = null;
        setEventValues(res.data);
      } else {
        AdnMessageError(t("manageEmployee.messages.errorUnCancelingEvent"));
      }
    });
  };

  const handleCancelEventFinish = async (values) => {
    await getEmployeeFollowUpEventById(eventFormValues.id).then((res) => {
      if (res.status === 200) {
        res.data.status = 3;
        res.data.note = values.note;
        setEventValues(res.data);
      } else {
        AdnMessageError(t("manageEmployee.messages.errorCancelingEvent"));
      }
    });
    setCancelEventVisible(false);
  };

  const handleShowHistoryModal = () => {
    getEmployeeContractHistoryInfo();
  };
  const handleCloseContractHistoryModal = () => {
    setShowContractHistoryModal(false);
  };

  useEffect(() => {
    const updateFollowUpEvent = async () => {
      if (eventValues.id !== undefined && eventValues.id !== null) {
        await updateEmployeeFollowUpEvent(eventValues).then((res) => {
          if (res.status === 200) {
            setRefetchFollowUpEventData(!refetchFollowUpEventData);
          }
        });
      }
    };

    updateFollowUpEvent();
  }, [eventValues]);

  useEffect(() => {
    if (searchReferenceBy !== "" && searchReferenceBy != null) {
      const getEmployeeData = async () => {
        await getEmployees(
          1,
          10,
          "name",
          searchReferenceBy,
          "",
          "",
          "",
          "",
          true
        ).then(async (res) => {
          if (res.data.totalRecords > 0) {
            const referenceByEmployeesList = res.data.result.filter(
              (employee) =>
                employee.resignationDate == null && employee.id !== employeeId
            );
            if (referenceByEmployeesList.length > 0) {
              referenceByEmployeesList[0].name.toLowerCase() ===
              searchReferenceBy.toLowerCase()
                ? setReferenceById(referenceByEmployeesList[0].id)
                : setReferenceById(null);
            } else {
              if (initValues.referenceBy !== searchReferenceBy) {
                setReferenceById(null);
              }
            }
            setReferenceByEmployees(referenceByEmployeesList);
          }
        });
      };

      getEmployeeData();
    } else {
      setReferenceByEmployees([]);
    }
  }, [searchReferenceBy]);

    return (
        <div>
            <EmployeeForm
                consultantForm={consultantForm}
                formTitle={pageHeader}
                criticalSituationsLinkPath={criticalSituationsLinkPath}
                isConsultant={isConsultant}
                setIsConsultant={setIsConsultant}
                templateQuestions={templateQuestions}
                onTemplateChangeHandle={onTemplateChangeHandle}
                selectedTemplateId={selectedTemplateId}
                careerLevels={availableCareerLevels}
                handleContractType={handleContractType}
                contractTypeList={contractTypeList}
                techSpecializedList={techSpecializedList}
                initialValues={initValues}
                managersList={managersList}
                humanResList={humanResList}
                onFormFinish={onFormFinish}
                visibleModalOffer={visibleModalOffer}
                setVisibleModalOffer={setVisibleModalOffer}
                event={event}
                setEvent={setEvent}
                inTransition={inTransition}
                offerData={offerData}
                setOfferData={setOfferData}
                employeeOfferData={employeeOfferData}
                setEmployeeOfferData={setEmployeeOfferData}
                handleFormOffer={handleFormOffer}
                setOfferHandler={setOfferHandler}
                offerHandler={offerHandler}
                getEmployeeOffer={getEmployeeOffers}
                disabledDateOffer={disabledDateOffer}
                templates={templates}
                onQuestion1Change={onQuestion1Change}
                onQuestion2Change={onQuestion2Change}
                onQuestion3Change={onQuestion3Change}
                onQuestion4Change={onQuestion4Change}
                onQuestion5Change={onQuestion5Change}
                onQuestion6Change={onQuestion6Change}
                isEditing={isEditing}
                isSentInquiryEmail={isSentInquiryEmail}
                setIsSentInquiryEmail={setIsSentInquiryEmail}
                isInquiryAnswered={isInquiryAnswered}
                setIsInquiryAnswered={setIsInquiryAnswered}
                disabledDateBirthDate={disabledDateBirthDate}
                loading={loading}
                inquiryForm={inquiryForm}
                submitInquiry={submitInquiry}
                getOfferListData={getOfferListData}
                fluencyLanguages={fluencyLanguages}
                setFluencyLanguages={setFluencyLanguages}
                templateAlreadySelected={templateAlreadySelected}
                employeeFollowUpEventData={employeeFollowUpEventData}
                workPlaceList={workPlaceList}
                countryList={countryList}
                saveImage={saveImage}
                image={image}
                handleChangeFollowUpPage={setCurrentPageFollowUp}
                totalRecordsFollowUp={totalRecordsFollowUp}
                haveAdmissionCti={haveAdmissionCti}
                formOffers={formOffers}
                employeeId={employeeId}
                onCancelOffersModal={onCancelOffersModal}
                handleChangeToCti={handleChangeToCti}
                isCTI={isCTI}
                handleBlurName={handleBlurName}
                handleBlurEmail={handleBlurEmail}
                onIsConsultantChange={onIsConsultantChange}
                isIntegrationEmailSent={isIntegrationEmailSent}
                isProfileEmailSent={isProfileEmailSent}
                modalSubmitLoading={modalSubmitLoading}
                submitLoading={submitLoading}
                imgLoading={imgLoading}
                haveAdmissionCps={haveAdmissionCps}
                openEmailModal={openEmailModal}
                handleFormEmail={handleFormEmail}
                emailModalTitle={emailModalTitle}
                visibleModalEmail={visibleModalEmail}
                emailSubmitLoading={emailSubmitLoading}
                onCancelEmailModal={onCancelEmailModal}
                handleSelectReferenceBy={handleSelectReferenceBy}
                handleSearchReferenceBy={handleSearchReferenceBy}
                referenceByEmployees={referenceByEmployees}
                referenceByName={referenceByName}
                isFirstAwardPaid={isFirstAwardPaid}
                isSecondAwardPaid={isSecondAwardPaid}
                handleFirstAward={setIsFirstAwardPaid}
                handleSecondAward={setIsSecondAwardPaid}
                referenceByBlur={referenceByBlur}
                companySatisfaction={companySatisfaction}
                projectSatisfaction={projectSatisfaction}
                clientSatisfaction={clientSatisfaction}
                followUpEventsProgressConfig={followUpEventsProgressConfig}
                offersProgressConfig={offersProgressConfig}
                employeeFollowUpEventsCounters={employeeFollowUpEventsCounters}
                employeeOffersCounters={employeeOffersCounters}
                tags={tags}
                tagInputRef={tagInputRef}
                tagEditInputRef={tagEditInputRef}
                tagInputVisible={tagInputVisible}
                tagInputValue={tagInputValue}
                editTagInputIndex={editTagInputIndex}
                editTagInputValue={editTagInputValue}
                setTagEditInputIndex={setTagEditInputIndex}
                setTagEditInputValue={setTagEditInputValue}
                handleCloseTag={handleCloseTag}
                showTagInput={showTagInput}
                handleTagInputChange={handleTagInputChange}
                handleTagInputConfirm={handleTagInputConfirm}
                handleTagEditInputChange={handleTagEditInputChange}
                handleTagEditInputConfirm={handleTagEditInputConfirm}
                isEmailEnglishLanguages={isEmailEnglishLanguages}
                setisEmailEnglishLanguages={setisEmailEnglishLanguages}
                isEmailSending={isEmailSending}
                isFirstMonthAssessmentEmailSent={isFirstMonthAssessmentEmailSent}
                isFirstMonthAssessmentAnswered={isFirstMonthAssessmentAnswered}
                firstMonthAssessmentQuestions={firstMonthAssessmentQuestions}
                isEmailEnglishLanguage={isEmailEnglishLanguage}
                percentage={percentage}
                totalRecordsEmployeeCertification={totalRecordsEmployeeCertification}
                employeeCertificationData={employeeCertificationData}
                isEditEnabled={isEditEnabled}
                setIsEditEnabled={setIsEditEnabled}
                disableEdit={disableEdit}
                saveEditChanges={saveEditChanges}
                showContractHistoryModal={showContractHistoryModal}
                handleShowHistoryModal={handleShowHistoryModal}
                employeeContractHistory={employeeContractHistory}
                handleCloseContractHistoryModal={handleCloseContractHistoryModal}
                visibleCancelRecommendationsModal={visibleCancelRecommendationsModal}
                setVisibleCancelRecommendationsModal={setVisibleCancelRecommendationsModal}
                handleCancelUnpaidRecommendations={handleCancelUnpaidRecommendations}
                handleCancelEventModal={handleCancelEventModal}
                handleUnCancelEvent={handleUnCancelEvent}
                cancelEventVisible={cancelEventVisible}
                setCancelEventVisible={setCancelEventVisible}
                cancelEventForm={cancelEventForm}
                handleCancelEventFinish={handleCancelEventFinish}
                assignedToList={assignedToList}
                handleAssignPerson={handleAssignPerson}
                unresolvedModalVisible={unresolvedModalVisible}
                setUnresolvedModalVisible={setUnresolvedModalVisible}
                ShowEditModal={ShowEditModal}
                handleTransition={handleTransition}
                confirmAssignPerson={confirmAssignPerson}
                eventEmployeeId={eventEmployeeId}
                eventAssignedToId={eventAssignedToId}
                handleChangeOffer={handleChangeOffer}
                handleChangeTechSpecializedName={handleChangeTechSpecializedName}
                techSpecializedName={techSpecializedName}
                handleOfferDate={handleOfferDate}
                managerEditPermission={managerEditPermission}
                cancelOfferVisible={cancelOfferVisible}
                cancelOfferForm={cancelOfferForm}
                setCancelOfferVisible={setCancelOfferVisible}
                offerFormValues={offerFormValues}
                handleCancelOfferModal={handleCancelOfferModal}
                resignationReasonOptions={resignationReasonOptions}
                hasResignationDate={hasResignationDate}
                handleResignationDateChange={handleResignationDateChange}
                isManager={isManager}
                hasCorpDepartureReason={hasCorpDepartureReason}
                departmentList={departmentList}
            />
        </div>
    );
};

export default ManageEmployeePage;
